export default __webpack_public_path__ + "static/media/dataBg.7bd7b38a.JPG";